/* eslint
    import/no-extraneous-dependencies: "warn",
    dot-notation: "off"
*/

import EasyfyDataLayer from '@shared/easyfy.datalayer';
import axios, { AxiosRequestConfig } from 'axios';
import Event from './easyfy.events/easyfy.eventhandler';

namespace Easyfy.Shared.Scripts {
  export interface IExtraHeaders {
    key: string;
    value: string;
  }

  export const get = async (
    url: string,
    config?: AxiosRequestConfig
  ): Promise<any> => {
    axios.defaults.headers.common["IsAxiosRequest"] = true;
    axios.defaults.headers.common["OriginalUrl"] = window.location.href;

    const response = await axios.get(url, config);
    Event.EasyfyEventHandler.RegisterResponseData(response);
    return EasyfyDataLayer.HandleDataEvents(response);
  };

  export const post = async (
    url: string,
    data: any,
    token?: string,
    config?: AxiosRequestConfig
  ): Promise<any> => {
    if (token) {
      axios.defaults.headers.common["RequestVerificationToken"] = token;
    }
    axios.defaults.headers.common["IsAxiosRequest"] = true;
    axios.defaults.headers.common["OriginalUrl"] = window.location.href;

    const response = await axios.post(url, data, config);
    Event.EasyfyEventHandler.RegisterResponseData(response);
    return EasyfyDataLayer.HandleDataEvents(response);
  };

  export const patch = async (
    url: string,
    data: any,
    token?: string,
    config?: AxiosRequestConfig
  ): Promise<any> => {
    if (token) {
      axios.defaults.headers.common["RequestVerificationToken"] = token;
    }
    axios.defaults.headers.common["IsAxiosRequest"] = true;
    axios.defaults.headers.common["OriginalUrl"] = window.location.href;

    const response = await axios.patch(url, data, config);
    Event.EasyfyEventHandler.RegisterResponseData(response);
    return EasyfyDataLayer.HandleDataEvents(response);
  };

  export const axiosDelete = async (
    url: string,
    token?: string,
    config?: AxiosRequestConfig
  ): Promise<any> => {
    if (token) {
      axios.defaults.headers.common["RequestVerificationToken"] = token;
    }
    axios.defaults.headers.common["IsAxiosRequest"] = true;
    axios.defaults.headers.common["OriginalUrl"] = window.location.href;

    const response = await axios.delete(url, config);
    Event.EasyfyEventHandler.RegisterResponseData(response);
    return EasyfyDataLayer.HandleDataEvents(response);
  };
}

export default Easyfy.Shared.Scripts;
